import React from "react";

function Star({ color }) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0069 3.45818L13.4722 12.6526L3.32639 14.1318C1.50695 14.3957 0.777779 16.6387 2.09722 17.9235L9.4375 25.0762L7.70139 35.1804C7.38889 37.0068 9.3125 38.3748 10.9236 37.5207L20 32.7498L29.0764 37.5207C30.6875 38.3679 32.6111 37.0068 32.2986 35.1804L30.5625 25.0762L37.9028 17.9235C39.2222 16.6387 38.4931 14.3957 36.6736 14.1318L26.5278 12.6526L21.9931 3.45818C21.1806 1.81929 18.8264 1.79846 18.0069 3.45818Z"
        fill={color}
      />
    </svg>
  );
}

export default Star;
